import { pathNames } from '@/shared/utils/constants'

import { Resources } from './types'

export const resourcesByRoute = new Map<string, Resources[]>()

const main = [Resources.MAIN_ASIDE, Resources.COMMON, Resources.ERRORS]

resourcesByRoute.set(pathNames.LOGIN, [Resources.LOGIN, Resources.COMMON])
resourcesByRoute.set(pathNames.INVITE_LOGIN, [Resources.LOGIN, Resources.COMMON])
resourcesByRoute.set(pathNames.CONFERENCE_INTERNAL_LINK_DENIED, [Resources.LOGIN, Resources.COMMON])
resourcesByRoute.set(pathNames.TOKEN_LOGIN, [Resources.LOGIN, Resources.COMMON])
resourcesByRoute.set(pathNames.MAIN, [...main, Resources.CHAT, Resources.CALLS])
resourcesByRoute.set(pathNames.CHAT, [...main, Resources.CHAT, Resources.CALLS])
resourcesByRoute.set(pathNames.CALL_SESSION, [...main, Resources.CHAT, Resources.CALLS])
resourcesByRoute.set(pathNames.VIEW_SETTINGS, [...main])
resourcesByRoute.set(pathNames.GENERAL, [...main, Resources.GENERAL])
resourcesByRoute.set(pathNames.SOUND_AND_VIDEO, [...main, Resources.SOUND_AND_VIDEO])
resourcesByRoute.set(pathNames.CALLS, [...main, Resources.CALLS_SETTINGS])
resourcesByRoute.set(pathNames.TERMINALS, [...main, Resources.TERMINALS])
resourcesByRoute.set(pathNames.ACCOUNT, [...main, Resources.ACCOUNT])
resourcesByRoute.set(pathNames.CONFIDENTIALITY, [...main])
resourcesByRoute.set(pathNames.NOTIFICATIONS, [...main, Resources.NOTIFICATIONS])
resourcesByRoute.set(pathNames.ALARM_SCHEDULE, [...main, Resources.NOTIFICATIONS])
resourcesByRoute.set(pathNames.AUDIO_FILES_SETTINGS, [...main, Resources.NOTIFICATIONS])
resourcesByRoute.set(pathNames.ABOUT, [...main, Resources.ABOUT])
resourcesByRoute.set(pathNames.GUEST_CALL_SESSION, [Resources.COMMON, Resources.CHAT, Resources.CALLS, Resources.GUEST])
resourcesByRoute.set(pathNames.GUEST_ROOM_CHAT, [Resources.COMMON, Resources.CHAT, Resources.GUEST])
resourcesByRoute.set(pathNames.SUPPORT_SETTINGS_GENERAL, [...main, Resources.GENERAL])
resourcesByRoute.set(pathNames.SUPPORT_SETTINGS_CALLS, [...main, Resources.CALLS_SETTINGS])
resourcesByRoute.set(pathNames.SUPPORT_SETTINGS_TERMINALS, [...main, Resources.TERMINALS])
resourcesByRoute.set(pathNames.SUPPORT_ACCOUNT, [...main, Resources.ACCOUNT])
resourcesByRoute.set(pathNames.SUPPORT_CONFIDENTIALITY, [...main])
resourcesByRoute.set(pathNames.SUPPORT_SETTINGS_NOTIFICATIONS, [...main, Resources.NOTIFICATIONS])
resourcesByRoute.set(pathNames.SUPPORT_ALARM_SCHEDULE, [...main, Resources.NOTIFICATIONS])
resourcesByRoute.set(pathNames.SUPPORT_AUDIO_FILES_SETTINGS, [...main, Resources.NOTIFICATIONS])
resourcesByRoute.set(pathNames.SUPPORT_SETTINGS_ABOUT, [...main, Resources.ABOUT])
resourcesByRoute.set(pathNames.PROFILE, [...main, Resources.PROFILE])
resourcesByRoute.set(pathNames.PROFILE_VOICE_MAIL, [...main, Resources.CALLS_SETTINGS, Resources.PROFILE])
